
import { useState } from 'react';
import Box from '@mui/material/Box';
import AppBarHeader from '../../components/AppBarHeader/AppBarHeader';
import FilterSidebar from '../../components/FilterSidebar/FilterSidebar';
import FilterToggle from '../../components/FilterSidebar/FilterToggle';
import GrowthHacksTable from '../../components/GrowthHacksTable/GrowthHacksTable';
import './Dashboard.scss';

const GrowthHacksIcon = ({ size = 75, color = '#FFE600' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: 5, marginTop: 22 }}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M8 6v30h32"
      stroke={color}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 30l9-9 7 6 10-12"
      stroke={color}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function Dashboard() {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleToggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  return (
    <Box className="dashboard-bg">
      <AppBarHeader />
      <div className="dashboard-heading-row">
        <div className="dashboard-heading-center">
          <GrowthHacksIcon />
          <div className="dashboard-heading-title">
            <h1>Growth Hacks</h1>
            <div className="dashboard-heading-underline"></div>
          </div>
        </div>        
      </div>
      
      {/* Mobile overlay */}
      {isFilterOpen && (
        <div 
          className="mobile-overlay" 
          onClick={handleToggleFilter}
        />
      )}
      
      <FilterToggle isOpen={isFilterOpen} onToggle={handleToggleFilter} />
      <FilterSidebar isOpen={isFilterOpen} />
      <Box className={`dashboard-content ${isFilterOpen ? 'with-sidebar' : 'without-sidebar'}`}>
        <Box className="dashboard-table-area">
          <GrowthHacksTable />
        </Box>
      </Box>
    </Box>
  );
}
